module.exports = __webpack_public_path__ + "static/media/5.6de5a778.png";